import { render, staticRenderFns } from "./ApplicationFormCompanyDocuments.vue?vue&type=template&id=52d9d05e&scoped=true"
import script from "./ApplicationFormCompanyDocuments.vue?vue&type=script&lang=ts"
export * from "./ApplicationFormCompanyDocuments.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationFormCompanyDocuments.vue?vue&type=style&index=0&id=52d9d05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d9d05e",
  null
  
)

export default component.exports